module.exports = __webpack_public_path__ + "static/media/logo-black-mobile.ca176879.svg";